import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import cn from 'classnames';
import { efesBlueish, efesGrayish } from '../../../../../theme';
import ChangePayableDialog from '../../../../../components/Dialogs/ChangePayableDialog';
import useDeviceResize from '../../../../../hooks/useDeviceResize';

import useStyles from './makeStyles';

const MobileTable = (props) => {
  const { data, handleRowClick, columns, handleUpdateContract } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [editableRow, setEditableRow] = useState({});
  const [editableColumn, setEditableColumn] = useState({});
  const [inputValue, setInputValue] = useState();
  const isDeviceXsSize = useDeviceResize('xs');

  const handleUpdate = () => {
    const newData = data.map((row) => {
      if (row.rowId === editableRow.rowId) {
        return {
          ...row,
          payable: inputValue,
        };
      }
      return row;
    });
    handleUpdateContract(newData);
  };

  return (
    <Grid container>
      {data.map((row) => (
        <Grid
          item
          xs={12}
          key={uniqueId()}
          onClick={() => handleRowClick(row)}
          className={cn({
            [classes.column]: true,
            [classes.disabled]: row.isDisabled,
          })}
          style={{
            borderTop: `6px solid ${row.isDisabled ? efesGrayish : efesBlueish} `,
          }}
        >
          {columns.map((column) => {
            const { property, customCell, title, headerCustomCell } = column;
            const cellContent = (
              <>{column.format ? column.format(row[property], row) : row[property]}</>
            );
            if (customCell) {
              const isPaid = column.property === 'payable' && row.isDisabled;
              return (
                !isPaid && (
                  <Grid container key={customCell} className={classes.row}>
                    <Grid item xs={isDeviceXsSize ? 5 : 6} className={classes.key}>
                      <Typography className={classes.title}>{t(title)}</Typography>
                    </Grid>
                    <Grid item xs={isDeviceXsSize ? 7 : 6} className={classes.value}>
                      <div className={classes.title}>
                        {customCell(row, column, setEditableRow, setEditableColumn, setOpen, props)}
                      </div>
                    </Grid>
                  </Grid>
                )
              );
            }
            if (headerCustomCell) {
              return (
                <Grid container key={headerCustomCell} className={classes.headerRow}>
                  <Grid item className={classes.value}>
                    {headerCustomCell(row, column, props)}
                  </Grid>
                </Grid>
              );
            }
            if (property && Object.prototype.hasOwnProperty.call(row, property)) {
              const columnTitle = column.title;
              return (
                <Grid container key={uniqueId()} className={classes.row}>
                  <Grid item xs={6} className={classes.key}>
                    <Typography className={classes.title}>{t(columnTitle)}</Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.value}>
                    <Typography className={classes.title}>{cellContent}</Typography>
                  </Grid>
                </Grid>
              );
            }
            return null;
          })}
        </Grid>
      ))}
      <ChangePayableDialog
        open={open}
        setOpen={setOpen}
        editableColumn={editableColumn}
        editableRow={editableRow}
        setEditableRow={setEditableRow}
        inputValue={inputValue}
        setInputValue={setInputValue}
        handleUpdate={handleUpdate}
      />
    </Grid>
  );
};

MobileTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleRowClick: PropTypes.func,
  handleUpdateContract: PropTypes.func.isRequired,
};

MobileTable.defaultProps = {
  handleRowClick: () => {},
};
export default MobileTable;
